import React from "react";
import SectionTryForFree from "@insightfulscience/atomic-react/SectionTryForFree";
import SectionTryForFreeLink from "@insightfulscience/atomic-react/SectionTryForFree/Link";
import { useLocale } from "@insightfulscience/i18";
import routes from "../../routes";

function TryForFree() {
	const [t] = useLocale("common");

	return (
		<SectionTryForFree>
			<SectionTryForFree.Title>
				Experience the future of flow cytometry.
			</SectionTryForFree.Title>
			<SectionTryForFree.Action>
				<SectionTryForFreeLink
					styleType="secondary"
					href={routes.freeTrial.url}
					data-qa-selector="tryForFreeAction"
				>
					{t("TRY_FOR_FREE")}
				</SectionTryForFreeLink>
			</SectionTryForFree.Action>
		</SectionTryForFree>
	);
}

export default TryForFree;
